import { render, staticRenderFns } from "./parts-orders.vue?vue&type=template&id=62758273&scoped=true"
import script from "./parts-orders.vue?vue&type=script&lang=js"
export * from "./parts-orders.vue?vue&type=script&lang=js"
import style0 from "./parts-orders.vue?vue&type=style&index=0&id=62758273&prod&scoped=true&lang=css"
import style1 from "./parts-orders.vue?vue&type=style&index=1&id=62758273&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62758273",
  null
  
)

export default component.exports